/* tslint:disable */
/* eslint-disable */
/**
 * BROStar API
 * Simplify the data management of the BRO
 *
 * The version of the OpenAPI document: v1
 * Contact: servicedesk@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface GLD
 */
export interface GLD {
  /**
   *
   * @type {string}
   * @memberof GLD
   */
  readonly uuid?: string;
  /**
   *
   * @type {string}
   * @memberof GLD
   */
  readonly linkedGmns?: string;
  /**
   *
   * @type {number}
   * @memberof GLD
   */
  readonly nrOfObservations?: number;
  /**
   *
   * @type {Date}
   * @memberof GLD
   */
  readonly created?: Date;
  /**
   *
   * @type {Date}
   * @memberof GLD
   */
  readonly updated?: Date;
  /**
   * Alleen beschikbaar voor de eigenaar van de put.
   * @type {string}
   * @memberof GLD
   */
  internalId: string | null;
  /**
   *
   * @type {string}
   * @memberof GLD
   */
  broId: string;
  /**
   *
   * @type {string}
   * @memberof GLD
   */
  deliveryAccountableParty: string | null;
  /**
   *
   * @type {string}
   * @memberof GLD
   */
  qualityRegime: string | null;
  /**
   *
   * @type {string}
   * @memberof GLD
   */
  gmwBroId: string | null;
  /**
   *
   * @type {string}
   * @memberof GLD
   */
  tubeNumber: string | null;
  /**
   *
   * @type {Date}
   * @memberof GLD
   */
  researchFirstDate: Date | null;
  /**
   *
   * @type {Date}
   * @memberof GLD
   */
  researchLastDate: Date | null;
  /**
   *
   * @type {string}
   * @memberof GLD
   */
  monitoringTube: string | null;
  /**
   *
   * @type {string}
   * @memberof GLD
   */
  dataOwner: string;
}

/**
 * Check if a given object implements the GLD interface.
 */
export function instanceOfGLD(value: object): value is GLD {
  if (
    (!("internalId" in (value as Record<string, any>)) &&
      !("internal_id" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["internalId"] === undefined &&
      (value as Record<string, any>)["internal_id"] === undefined)
  )
    return false;
  if (
    (!("broId" in (value as Record<string, any>)) &&
      !("bro_id" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["broId"] === undefined &&
      (value as Record<string, any>)["bro_id"] === undefined)
  )
    return false;
  if (
    (!("deliveryAccountableParty" in (value as Record<string, any>)) &&
      !("delivery_accountable_party" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["deliveryAccountableParty"] === undefined &&
      (value as Record<string, any>)["delivery_accountable_party"] === undefined)
  )
    return false;
  if (
    (!("qualityRegime" in (value as Record<string, any>)) &&
      !("quality_regime" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["qualityRegime"] === undefined &&
      (value as Record<string, any>)["quality_regime"] === undefined)
  )
    return false;
  if (
    (!("gmwBroId" in (value as Record<string, any>)) &&
      !("gmw_bro_id" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["gmwBroId"] === undefined &&
      (value as Record<string, any>)["gmw_bro_id"] === undefined)
  )
    return false;
  if (
    (!("tubeNumber" in (value as Record<string, any>)) &&
      !("tube_number" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["tubeNumber"] === undefined &&
      (value as Record<string, any>)["tube_number"] === undefined)
  )
    return false;
  if (
    (!("researchFirstDate" in (value as Record<string, any>)) &&
      !("research_first_date" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["researchFirstDate"] === undefined &&
      (value as Record<string, any>)["research_first_date"] === undefined)
  )
    return false;
  if (
    (!("researchLastDate" in (value as Record<string, any>)) &&
      !("research_last_date" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["researchLastDate"] === undefined &&
      (value as Record<string, any>)["research_last_date"] === undefined)
  )
    return false;
  if (
    (!("monitoringTube" in (value as Record<string, any>)) &&
      !("monitoring_tube" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["monitoringTube"] === undefined &&
      (value as Record<string, any>)["monitoring_tube"] === undefined)
  )
    return false;
  if (
    (!("dataOwner" in (value as Record<string, any>)) &&
      !("data_owner" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["dataOwner"] === undefined &&
      (value as Record<string, any>)["data_owner"] === undefined)
  )
    return false;
  return true;
}

export function GLDFromJSON(json: any): GLD {
  return GLDFromJSONTyped(json, false);
}

export function GLDFromJSONTyped(json: any, ignoreDiscriminator: boolean): GLD {
  if (json == null) {
    return json;
  }
  return {
    uuid: json["uuid"] == null ? undefined : json["uuid"],
    linkedGmns: json["linked_gmns"] == null ? undefined : json["linked_gmns"],
    nrOfObservations: json["nr_of_observations"] == null ? undefined : json["nr_of_observations"],
    created: json["created"] == null ? undefined : new Date(json["created"]),
    updated: json["updated"] == null ? undefined : new Date(json["updated"]),
    internalId: json["internal_id"],
    broId: json["bro_id"],
    deliveryAccountableParty: json["delivery_accountable_party"],
    qualityRegime: json["quality_regime"],
    gmwBroId: json["gmw_bro_id"],
    tubeNumber: json["tube_number"],
    researchFirstDate:
      json["research_first_date"] == null ? null : new Date(json["research_first_date"]),
    researchLastDate:
      json["research_last_date"] == null ? null : new Date(json["research_last_date"]),
    monitoringTube: json["monitoring_tube"],
    dataOwner: json["data_owner"],
  };
}

export function GLDToJSON(json: any): GLD {
  return GLDToJSONTyped(json, false);
}

export function GLDToJSONTyped(
  value?: Omit<GLD, "uuid" | "linked_gmns" | "nr_of_observations" | "created" | "updated"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    internal_id: value["internalId"],
    bro_id: value["broId"],
    delivery_accountable_party: value["deliveryAccountableParty"],
    quality_regime: value["qualityRegime"],
    gmw_bro_id: value["gmwBroId"],
    tube_number: value["tubeNumber"],
    research_first_date:
      value["researchFirstDate"] == null
        ? value["researchFirstDate"]
        : value["researchFirstDate"].toISOString().substring(0, 10),
    research_last_date:
      value["researchLastDate"] == null
        ? value["researchLastDate"]
        : value["researchLastDate"].toISOString().substring(0, 10),
    monitoring_tube: value["monitoringTube"],
    data_owner: value["dataOwner"],
  };
}
